import Component from '@cell/cell-core/component/component';
import './scroll-info.scss';

class ScrollInfo extends Component {
  constructor() {
    super();
  }

  componentDidMount() {}

  show() {
    this.classList.add('ScrollInfo--Active');

    setTimeout(() => {
      this.classList.add('ScrollInfo--Visible');
    }, 100);
  }

  hide() {
    this.classList.remove('ScrollInfo--Visible');

    setTimeout(() => {
      this.classList.remove('ScrollInfo--Active');
    }, 100);
  }
}

customElements.define('scroll-info', ScrollInfo);
